import { useFormContext, useWatch, UseFormProps, UseFormReturn } from "react-hook-form";

import { useAppStore } from '../store/appStore';

import { cleanSsn } from '../lib/strFunctions/cleanSsid'

import { Box, IconButton, Button, Card, CardContent, Typography, LinearProgress } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2'
import { Clear, Delete } from '@mui/icons-material'

import { IPerson } from "../lib/interfaces/models";

import { TextInput } from "../components/TextInput";
import { EmailInput } from "../components/EmailInput";




interface IGuardianFormProps {
  index: number
  onRemove: (index: number) => void
  disableRemoveButton: boolean
  type?: string
}

export const GuardianForm = ({
  index,
  onRemove,
  disableRemoveButton,
}: IGuardianFormProps) => {
  const form: UseFormReturn<UseFormProps> = useFormContext();

  return (
    <Box sx={{ minWidth: 275, mt: 1 }}>
      <Card variant="outlined" sx={{ backgroundColor: '#EAF2F1', borderRadius: .6  }}>
        <CardContent>
          <Typography variant="h6" gutterBottom sx={{ ml: 1 }}>

            {
              !disableRemoveButton &&
              <IconButton
              disabled={disableRemoveButton}
              onClick={() => onRemove(index)}
              sx={{pl: 0}}
              >
                <Clear />
              </IconButton>
            }
            Forráðamaður
            {(index > 0) && <>{` ${index + 1}`}</>}
            {(index === 0) && <> / greiðandi</>}


          </Typography>
          <Grid container spacing={1}>

            <Grid xs={12} sm={3.2} md={1.8} lg={1.5} xl={1.15}>
              <TextInput name={`guardians[${index}].ssid`} type="tel" label="Kennitala" placeholder="Sláið inn hér" />
            </Grid>
            <Grid xs={12} sm={8.7} md={4.8} lg={5} xl={5}>
              <TextInput name={`guardians[${index}].name`} label="Nafn" placeholder="Sláið inn hér" />
            </Grid>
            <Grid xs={12} sm={3.2} md={1.8} lg={1.5} xl={1.15}>
              <TextInput name={`guardians[${index}].tel1`} type="tel" label="GSM sími" placeholder="Símanr" />
            </Grid>

            <Grid xs={12} sm={3.2} md={1.8} lg={1.5} xl={1.15}>
              <TextInput name={`guardians[${index}].tel2`} type="tel" label="Sími 2" placeholder="Símanr" />
            </Grid>

            <Grid xs={12} sm={3.2} md={1.8} lg={1.5} xl={1.15}>
              <TextInput name={`guardians[${index}].tel3`} type="tel" label="Sími 3" placeholder="Símanr" />
            </Grid>
            <Grid xs={12} sm={12} md={4} lg={4} xl={4}>
              <EmailInput name={`guardians[${index}].email1`} type="email" label="Netfang" placeholder="Sláið inn hér" />
            </Grid>
            <Grid xs={12} sm={12} md={4} lg={4} xl={4}>
            <EmailInput name={`guardians[${index}].email2`} type="email" label="Netfang 2 (ef við á)" placeholder="Sláið inn hér" />
            </Grid>
            <Grid xs={12} sm={12} md={4} lg={4} xl={4}>
            <EmailInput name={`guardians[${index}].email3`} type="email" label="Netfang 3 (ef við á)" placeholder="Sláið inn hér" />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  )
}